import React, { useRef, useState } from "react";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { getCurrentDate } from "../../../../Utilitie";

const IreMonthWiseTable = ({ data, activeMetrics }) => {
  const tableRef = useRef();

  const monthOrder = [
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "January",
    "February",
    "March",
  ];

  if (!Array.isArray(data) || data.length === 0) {
    return <p>No data available</p>;
  }

  const fy1 = data[0]?.financial_year || "N/A";
  const fy2 = data[1]?.financial_year || "N/A";

  const mergedData = {};

  data.forEach((yearData) => {
    yearData.children?.forEach((monthEntry) => {
      const month = monthEntry.monthName;

      if (!mergedData[month]) {
        mergedData[month] = {};
      }
      mergedData[month][yearData.financial_year] = monthEntry.data[0];
    });
  });

  const getKey = (suffix) => `${activeMetrics}_${suffix}`;

  return (
    <div>
      {" "}
      {/* <select
        className="form-select  text-black fw-bolder text-center"
        onChange={(e) => {
          setactiveMetrics(e.target.value);
        }}
      >
        <option>JUMBO</option>
        <option>NBOX</option>
        <option>BTPN</option>
      </select> */}
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table newUiTable table-hover table-striped table-bordered"
          style={{ fontSize: "13px" }}
        >
          <thead>
            <tr
              className="table-dark text-center"
              style={{ fontWeight: "bold" }}
            >
              <th rowSpan={2} className="align-middle">
                MONTH
              </th>
              <th colSpan="4">FINANCIAL YEAR ({fy2})</th>
              <th colSpan="4">FINANCIAL YEAR ({fy1})</th>
              <th rowSpan={2} className="align-middle text-wrap">
                VARIATION TOTAL PERCENTILE
              </th>
            </tr>
            <tr className="table-dark text-center">
              <th className="text-wrap">
                {getKey("RECD_tot").replaceAll("_", " ").replaceAll("tot", "")}{" "}
                TOTAL
              </th>

              <th className="text-wrap">
                {getKey("IRE_tot").replaceAll("_", " ").replaceAll("tot", "")}{" "}
                TOTAL
              </th>
              <th className="text-wrap">
                {getKey("Y_DAY_O_B_tot")
                  .replaceAll("_", " ")
                  .replaceAll("tot", "")}{" "}
                TOTAL
              </th>
              <th className="text-wrap">
                {getKey("PERCENTILE_tot")
                  .replaceAll("_", " ")
                  .replaceAll("tot", "")}{" "}
                TOTAL
              </th>
              <th className="text-wrap">
                {getKey("RECD_tot").replaceAll("_", " ").replaceAll("tot", "")}{" "}
                TOTAL
              </th>
              <th className="text-wrap">
                {getKey("IRE_tot").replaceAll("_", " ").replaceAll("tot", "")}{" "}
                TOTAL
              </th>
              <th className="text-wrap">
                {getKey("Y_DAY_O_B_tot")
                  .replaceAll("_", " ")
                  .replaceAll("tot", "")}{" "}
                TOTAL
              </th>
              <th className="text-wrap">
                {getKey("PERCENTILE_tot")
                  .replaceAll("_", " ")
                  .replaceAll("tot", "")}{" "}
                TOTAL
              </th>
            </tr>
          </thead>
          <tbody>
            {monthOrder
              .filter((month) => mergedData[month])
              .map((month) => {
                const fy1Data = mergedData[month][fy1] || {};
                const fy2Data = mergedData[month][fy2] || {};
                const variation =
                  fy2Data[getKey("PERCENTILE_tot")] !== 0
                    ? (
                        ((fy1Data[getKey("PERCENTILE_tot")] -
                          fy2Data[getKey("PERCENTILE_tot")]) *
                          100) /
                        fy2Data[getKey("PERCENTILE_tot")]
                      ).toFixed(2)
                    : "-";

                return (
                  <tr key={month} className="text-center">
                    <td>{month}</td>
                    <td>{fy2Data[getKey("RECD_tot")] || null}</td>
                    <td>{fy2Data[getKey("IRE_tot")] || null}</td>
                    <td>{fy2Data[getKey("Y_DAY_O_B_tot")] || null}</td>

                    <td>
                      {fy2Data[getKey("PERCENTILE_tot")] != null
                        ? `${fy2Data[getKey("PERCENTILE_tot")]}%`
                        : null}
                    </td>
                    <td>{fy1Data[getKey("RECD_tot")] || null}</td>
                    <td>{fy1Data[getKey("IRE_tot")] || null}</td>
                    <td>{fy1Data[getKey("Y_DAY_O_B_tot")] || null}</td>
                    <td>
                      {fy1Data[getKey("PERCENTILE_tot")] != null
                        ? `${fy1Data[getKey("PERCENTILE_tot")]}%`
                        : null}
                    </td>

                    <td>
                      {fy2Data[getKey("Y_DAY_O_B_tot")] != null &&
                      fy1Data[getKey("Y_DAY_O_B_tot")] != null ? (
                        <div
                          className="m-1 text-center"
                          style={{
                            borderRadius: "5px",
                            background:
                              variation > 0
                                ? "rgba(88, 223, 61, 0.78)"
                                : "rgba(233, 75, 75, 0.9)",
                          }}
                        >
                          {variation > 0 ? (
                            <BsFillCaretUpFill />
                          ) : (
                            <BsFillCaretDownFill />
                          )}
                          {variation}%
                        </div>
                      ) : null}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`IRE Month wise data  - ${getCurrentDate()}`}
      />
    </div>
  );
};

export default IreMonthWiseTable;
